<form (ngSubmit)="onSubmit(AddPartnerUserForm)" #AddPartnerUserForm="ngForm">
    <p-dialog  [(visible)]="displayAddDialogInput" 
      [modal]="true"
      [positionTop]="50"
      [maximizable]="true"
      (onHide)="dialogClose()" 
      (onShow)="dialogOpen()">
    
    <p-header>
        <b>Add Partner User</b>
    </p-header>

    <div class="ui-grid ui-grid-responsive formcontainer custom-dialog-content">
      <p-fieldset>
        <p-header class="fieldsetHeader">User Details</p-header>
        <div class="formgroup" [class.has-error]="email.invalid && email.touched" [class.has-success]="email.valid">
            <div class="ui-grid-row">
              <label for="Email">Email Address <span class="custom-required">*</span></label>
            </div>
            <div class="ui-grid-row"> 
                <div class="ui-grid-col-12">
                  <input type="text" pInputText name="Email" id="Email" size="35" [(ngModel)]="this.person.Email" #email="ngModel" required customEmail personEmailExists>
                </div>
            </div>  
            <span *ngIf="(email.errors?.required && email.touched)" class="custom-error">Email is required.</span>
            <span *ngIf="(email.errors?.email || email.errors?.invalidEmail) && email.touched" class="custom-error">Email is invalid.</span>
            <div *ngIf="email.pending">Email Verification in progress...</div>
            <div class="custom-error" *ngIf="email.invalid && (email.dirty || email.touched) && email.errors.emailExists">
              This user already exists in this partnership.
            </div>
        </div>

        <div class="formgroup">
          <div class="ui-grid-row">
            <div class="ui-grid-col-12">
              <label for="UniqueKey">Unique Key</label>
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-grid-col-12">
                <input type="text" pInputText name="uniqueKey" id="uniqueKey" size="35" [(ngModel)]="this.partnerUser.UniqueKey">
            </div>
          </div>
        </div>
      </p-fieldset>

      <p-fieldset>
        <p-header class="fieldsetHeader">Partner Details</p-header>
        <div class="formgroup">
            <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                    <label for="partnertype">Partner Type</label><br>
                </div>
            </div>
            <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                    {{partnerDetails.RelationshipType}}
                </div>
            </div>
        </div>
        <div class="formgroup">
            <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                    <label for="partner">Partner</label>
                </div>
            </div>
            <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                    {{partnerDetails.CompanyName}}
                </div>
            </div>
        </div>

        <div class="formgroup">
            <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                    <label for="MasterAssetGroup">Master Asset Group</label>
                </div>
            </div>
            <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  {{partnerDetails.AssetGroupList}}
                </div>
            </div>    
        </div>

        <div class="formgroup">
          <div class="ui-grid-row">
              <div class="ui-grid-col-12">
                <label for="Privileges">Privileges<span class="custom-required">*</span></label>
              </div>
          </div>
          <div class="ui-grid-row">
            <app-privilege-dropdown
              [privilegeGroup]="partnershipPrivileges" 
              [preSelectedPrivilege]="partnershipPrivileges"
              [maxSelectedLabels]="1"
              [group]=true
              defaultLabel="Select Privilege" 
              filterPlaceHolder=""
              (onChange)="privilegeChange($event)">
            </app-privilege-dropdown>
            <i class="pi pi-info-circle" style="font-size:24px"
              pTooltip="Privileges control what each user is able to see and do in the EQ Connect Portal.  If this user is given the privilege to add/edit other users in the Portal, they can only give other users the privileges they have."></i>
            <span [ngClass]="{'check-circle-gray': selectedItemsNow?.length <=0,
                                        'check-circle-green': selectedItemsNow?.length > 0}">
              <i class="pi pi-check-circle"></i>
            </span>
          </div>
          <span *ngIf="selectedItemsNow?.length <=0" class="custom-error">Privileges are required</span>
        </div>
      </p-fieldset>
    </div>
  
  <p-footer>
    <button pButton type="button" label="Cancel" class="ui-button-secondary" (click)="dialogClose()"></button>
    <button pButton type="submit" label="{{processing ? 'Processing' : 'Create User'}}" [disabled]="!AddPartnerUserForm.form.valid || email.pending || selectedItemsNow?.length <=0 ||processing"></button>
  </p-footer>
</p-dialog>
</form>